import React, { useState, useEffect, useRef } from "react";
import axiosClient from "../api/axiosClient";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function MCQPage() {
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState({});
  const [status, setStatus] = useState({});
  const [time, setTime] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [attemptDate, setAttemptDate] = useState("");
  
const navigate = useNavigate()
  // 🔥 YAHAN ADD KAR
  const hasFetched = useRef(false);
/*
  useEffect(() => {
    if (hasFetched.current) return;   // 🔥 STOP DUPLICATE
    hasFetched.current = true;

    const fetchQuestions = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axiosClient.get("/auth/assign-test/reasoning", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("API RESPONSE 👉", res.data);

        const questionsData = res?.data;

        if (!questionsData || questionsData.length === 0) {
          setQuestions([]);
        } else {
          setQuestions(questionsData);
        }

      } catch (err) {
        console.error("❌ API ERROR:", err);
        setQuestions([]);
      }
    };

    fetchQuestions();
  }, []);
*/
useEffect(() => {
  if (hasFetched.current) return;
  hasFetched.current = true;

  const fetchQuestions = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axiosClient.get(
        "/auth/assign-test/reasoning",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = res.data;

      // ✅ Free Plan Limit Popup
      if (
        typeof data === "string" &&
        data.includes("Only 1 test per day")
      ) {
        await Swal.fire({
          icon: "info",
          title: "Daily Test Limit Reached 🚫",
          html: `
            <div style="font-size:15px; line-height:1.6;">
              You have already used your <b>1 free test</b> for today.<br><br>
              Please come back <b>tomorrow</b> for your next attempt.
            </div>
          `,
          confirmButtonText: "Go Back",
          confirmButtonColor: "#7c3aed",
          background: "#ffffff",
          color: "#111827",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        navigate("/front")
        return;
      }

      // ✅ Questions Load
      setQuestions(data);

    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data ||
        "Something went wrong";

      // ✅ Better Error Popup
      await Swal.fire({
        icon: "warning",
        title: "Unable to Start Test",
        html: `
          <div style="font-size:15px; line-height:1.6;">
            ${msg}
          </div>
        `,
        confirmButtonText: "Go Back",
        confirmButtonColor: "#7c3aed",
        background: "#ffffff",
        color: "#111827",
      });

      navigate("/front")
    }
  };

  fetchQuestions();
}, []);
  // 🔥 TIMER
  useEffect(() => {
    setTime(0);

    const timer = setInterval(() => {
      setTime((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [current]);

  const formatTime = () => {
    const m = Math.floor(time / 60);
    const s = time % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };




  // SELECT
  const handleSelect = (i) => {
    setAnswers({ ...answers, [current]: i });

    setStatus((prev) => ({
      ...prev,
      [current]: "DONE",
    }));

    // 🔥 SAVE API CALL
    saveProgress(i);
  };



  const saveProgress = async (selectedIndex) => {
    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");

      const payload = {
        userId: userId,
        testName: q?.testName,            // 🔥 backend se aa raha
        questionId: q?.questionId,        // 🔥 IMPORTANT
        questionFormat: "MCQ",
        userAnswer: ["A", "B", "C", "D"][selectedIndex], // option mapping
        totalTimeSeconds: time,
      };

      console.log("SAVE API PAYLOAD 👉", payload);

      await axiosClient.post(
        "/auth/save-question-progress",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("✅ Saved successfully");

    } catch (err) {
      console.error("❌ Save API error:", err);
    }
  };


  const finishTest = async () => {
    try {
      const token = localStorage.getItem("token");

      const testName = q?.testName;   // 🔥 yahi bhejna hai

      console.log("FINISH TEST NAME 👉", testName);

      await axiosClient.post(
        "/auth/finish-test",
        {},   // ❌ body empty rakho
        {
          params: { testName },   // 🔥 🔥 YAHI FIX
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("✅ Test Finished");

      // ✅ POPUP
      await Swal.fire({
        title: "Test Submitted 🎉",
        text: "Your test has been submitted successfully!",
        icon: "success",
        confirmButtonText: "Go to Review ",
        confirmButtonColor: "#7c3aed",
        background: "#fff",
        color: "#111",
      });

    window.location.href = `/review/${testName}`;

    } catch (err) {
      console.error("❌ Finish API error:", err);
    }
  };

  // NEXT
  const nextQuestion = () => {

    // 🔥 SKIP SAVE
    if (answers[current] === undefined) {
      setStatus((prev) => ({
        ...prev,
        [current]: "SKIP",
      }));

      saveProgress(null);
    }

    // 🔥 LAST QUESTION → FINISH API CALL
    if (current === questions.length - 1) {
      finishTest();   // 🔥 YAHAN CALL
      return;
    }

    // 🔥 NORMAL NEXT
    setCurrent(current + 1);
  };
  const prevQuestion = () => {
    if (current > 0) setCurrent(current - 1);
  };

  // LOADING
  if (!questions.length) {
    // return (
    //   <div style={{ padding: 50, textAlign: "center" }}>
    //     ❌ No Questions Available
    //   </div>
    // );
  }

  const q = questions[current];

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>Aptitude Test</h2>
          <p style={styles.sub}>
            Question {current + 1} of {questions.length}
          </p>
        </div>

        <div style={styles.timer}>⏱ {formatTime()}</div>
      </div>

      {/* PROGRESS */}
      <div style={styles.progressBar}>
        <div
          style={{
            ...styles.progressFill,
            width: `${((current + 1) / questions.length) * 100}%`,
          }}
        />
      </div>

      {/* QUESTION */}
      <div style={styles.card}>
        <p style={styles.qText}>{q?.question}</p>

        {[
          q?.optionA,
          q?.optionB,
          q?.optionC,
          q?.optionD,
        ]
          .filter(Boolean)
          .map((opt, i) => (
            <div
              key={i}
              onClick={() => handleSelect(i)}
              style={{
                ...styles.option,
                border:
                  answers[current] === i
                    ? "2px solid #7c3aed"
                    : "1px solid #ddd",
                background:
                  answers[current] === i ? "#f3e8ff" : "#fff",
              }}
            >
              <span style={styles.radio}>
                {answers[current] === i && "✔"}
              </span>
              {opt}
            </div>
          ))}
      </div>

      {/* NAVIGATION */}
      <div style={styles.navCard}>
        <p style={styles.navTitle}>Questions</p>

        <div style={styles.dots}>
          {questions.map((_, i) => {
            let bg = "#d1d5db";

            if (status[i] === "DONE") bg = "#22c55e";
            else if (status[i] === "SKIP") bg = "#ef4444";

            return (
              <div
                key={i}
                onClick={() => setCurrent(i)}
                style={{
                  ...styles.dot,
                  background: bg,
                  border:
                    current === i
                      ? "none"
                      : "none",
                }}
              >
                {i + 1}
              </div>
            );
          })}
        </div>
      </div>

      {/* FOOTER */}
      <div style={styles.footer}>
        <button onClick={prevQuestion} style={styles.prevBtn}>
          Previous
        </button>

        <button onClick={nextQuestion} style={styles.nextBtn}>
          {current === questions.length - 1
            ? "Finish"
            : "Next →"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    background: "linear-gradient(135deg,#eef2ff,#fdf4ff)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
  },

  header: {
    width: "100%",
    maxWidth: "1200px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  title: { margin: 0 },

  sub: {
    margin: 0,
    fontSize: "14px",
    color: "#6b7280",
  },

  timer: {
    background: "#ede9fe",
    padding: "8px 14px",
    borderRadius: "20px",
    fontWeight: "600",
    color: "#7c3aed",
  },

  progressBar: {
    width: "100%",
    maxWidth: "1200px",   // 🔥 change
    height: "6px",
    background: "#e5e7eb",
    borderRadius: "10px",
    margin: "10px 0 20px",
  },

  progressFill: {
    height: "100%",
    background: "#7c3aed",
    borderRadius: "10px",
  },

  card: {
    width: "100%",
    maxWidth: "1200px",
    background: "#fff",
    padding: "25px",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  },

  qText: {
    fontSize: "18px",
    marginBottom: "20px",
  },

  option: {
    padding: "14px",
    borderRadius: "12px",
    marginBottom: "10px",
    cursor: "pointer",
    display: "flex",
    gap: "10px",
  },

  radio: {
    width: "20px",
    height: "20px",
    border: "2px solid #7c3aed",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  navCard: {
    width: "100%",
    maxWidth: "1200px",
    background: "#fff",
    padding: "20px",
    borderRadius: "14px",
    marginTop: "20px",
    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
  },

  navTitle: {
    marginBottom: "10px",
    fontWeight: "600",
  },

  dots: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
  },

  dot: {
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    cursor: "pointer",
  },

  footer: {
    width: "100%",
    maxWidth: "1200px",
    marginTop: "20px",
    display: "flex",
    justifyContent: "space-between",
  },

  prevBtn: {
    padding: "10px 20px",
    borderRadius: "20px",
    border: "none",
    background: "#e5e7eb",
  },

  nextBtn: {
    padding: "10px 25px",
    borderRadius: "25px",
    border: "none",
    background: "#7c3aed",
    color: "#fff",
  },
};